export default __webpack_public_path__ + "static/media/shoot.e789317a.svg";